import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';

import { Observable, map } from 'rxjs';

interface GeoapifyResponse {
  results: Array<{
    city?: string;
    state?: string;
    country?: string;
  }>;
}
@Injectable({
  providedIn: 'root',
})
export class LocationService {
  private apiKey = environment.apiKey;

  constructor(private http: HttpClient) {}

  getCityFromCoords(lat: number, lon: number): Observable<string> {
    const url = `https://api.geoapify.com/v1/geocode/reverse?lat=${lat}&lon=${lon}&format=json&apiKey=${this.apiKey}`;

    return this.http.get<GeoapifyResponse>(url).pipe(
      map((res) => {
        const r = res.results?.[0];
        console.log('Parsed result:', r);
        return r?.state || 'Unknown City';
      })
    );
  }

  getUserLocation(): Promise<{ latitude: number; longitude: number }> {
    return new Promise((resolve, reject) => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            resolve({
              latitude: position.coords.latitude,
              longitude: position.coords.longitude,
            });
          },
          (error) => {
            reject(error);
          }
        );
      } else {
        reject(new Error('Geolocation is not supported by this browser.'));
      }
    });
  }
}
